import { Column, FileManagerRow, FMColumn } from '../model';

import { Type } from '../../../../general/modules/filter/dataModel';
import { userFullName } from '../../../../general/model';
import { managerCol } from './managerCol';
export const developerCol: FMColumn<Type.ID> = {
  ...managerCol,
  key: Column.developer,
  dataKey: Column.developer,
  title: 'Developer',
  getter: (n: FileManagerRow) => {
    const mgrUser = n.creative?.executor ?? null;
    if (mgrUser === null) return null;
    return userFullName(mgrUser);
  },
  toDisplayString: (n: FileManagerRow) => {
    const mgrUser = n.creative?.executor ?? null;
    if (mgrUser === null) return null;
    return userFullName(mgrUser);
  },
};
